module.exports = __webpack_public_path__ + "img/f357d7ac5762017770487885d6eb168a.svg";